import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloProvider, ApolloClient} from '@apollo/client';
import {InMemoryCache} from '@apollo/client/cache';
import {createUploadLink} from 'apollo-upload-client';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {QueryParamProvider} from 'use-query-params';
import Contact from './components/contact';

const cache = new InMemoryCache({});

const link = createUploadLink({
  uri: '/graphql',
  credentials: 'include',
});

const client = new ApolloClient({
  cache,
  link,
});

const ContactApp = () => (
  <ApolloProvider client={client}>
    <Router>
      <QueryParamProvider ReactRouterRoute={Route}>
        <Contact />
      </QueryParamProvider>
    </Router>
  </ApolloProvider>
);

export default ContactApp;

ReactDOM.render(<ContactApp />, document.getElementById('contact'));
